import { useMergedCueState } from '@/hooks/use-merged-cue-state';
import type { FlowCueStateV1, PerformControlV1 } from '@/types/player/perform-control-v1.types.ts';

/**
 * Reads auto-cue state from the perform-control store (owner hydrates GET).
 * Extra GET args stay for call-site compatibility and optional merge.
 */
export function useLiveContextCueState(
  entityRef: string | undefined,
  performControlFromGet?: PerformControlV1,
  cueStateFromGet?: FlowCueStateV1,
  querySnapshotKey?: number,
): FlowCueStateV1 | undefined {
  void performControlFromGet;
  void querySnapshotKey;
  return useMergedCueState(entityRef, cueStateFromGet);
}
